const siteMetadata = {
    title: `Next Gen Editing`,
    siteUrl: `http://localhost`,
    capitalizeTitleOnHome: false,
    logo: `/images/logo.png`,
    icon: `/images/icon.png`,
    titleImage: `/images/nci-wall-small.jpg`,
    ogImage: `/images/nci-wall-small.jpg`,
    twoColumnWall: true,
    cookiePolicy: true,
    introTag: `GENE EDITOR | INVESTOR | ENTREPRENEUR | PILOT`,
    description: `I work to edit genes and improve humanity by curing illneses ranging from cancer to aging. And I fly planes!`,
    about:
        "Next Gen Editing is a consulting firm focused on unlocking the full potential of gene editing to create medicines that re-write DNA in order to cure disease, improve the quality of life, and allow us to live long, healthy, and fulfilling lives.",
    author: `@kernytsky`,
    blogItemsPerPage: 10,
    portfolioItemsPerPage: 10,
    darkmode: true,
    switchTheme: true,
    navLinks: [
        {
            name: "NEXT GEN EDITING",
            url: "/",
        },
        {
            name: "ABOUT",
            url: "/about",
        },
        {
            name: "BLOG",
            url: "/blog",
        },
        {
            name: "PROJECTS",
            url: "/portfolio",
        },
        {
            name: "CONTACT",
            url: "/contact",
        },
    ],
    footerLinks: [
        {
            name: "PRIVACY POLICY",
            url: "/privacy-policy",
        },
    ],
    social: [
        {
            name: "Twitter",
            icon: "/images/Twitter.svg",
            url: "https://twitter.com/kernytsky",
        },
        {
            name: "LinkeIn",
            icon: "/images/icons8-linkedin-circled.svg",
            url: "https://linkedin.com/in/kernytsky",
        },
    ],
    contact: {
        // leave empty ('') or false to hide form
        api_url: "",
        //api_url: "https://getform.io/f/fd5b88c3-11a1-4794-8b44-15ca446bc097",
        description: `Contact via email address by removing the ! and figuring out the rest`,
        mail: "andrew !AT! nextgenedit !DOT! com",
        phone: "",
        address: "",
    },
    disqus: "elemental-netlify-com",
}

const beforeContactFormSubmit = data => {
    // Code 0 - success
    // Code 1 - Name
    // Code 2 - Email
    // Code 3 - Message
    // Code 4 - Other
    const errors = []

    if (data.name.trim().length < 2) {
        errors.push({
            code: 1,
            message: "Enter a name",
        })
    }

    if (!data.email.match(/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/)) {
        errors.push({
            code: 2,
            message: "Enter a valid email address",
        })
    }

    if (data.message.trim().length < 15) {
        errors.push({
            code: 3,
            message: "Enter a message with atleast 15 characters",
        })
    }

    if (errors.length > 0)
        return {
            result: false,
            errors: errors,
        }

    return {
        data: {
            name: data.name,
            email: data.email,
            message: data.message,
        },
        result: true,
    }
}

const contactFormSubmit = async (api, data) => {
    let res: any = await fetch(api, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })

    res = await res.json()

    if (res.success) {
        return {
            result: true,
        }
    }
    return {
        result: false,
        ...res,
    }
}

const defaults = {
    disqus: null,
    twoColumnWall: true,
    darkmode: false,
    switchTheme: true,
    capitalizeTitleOnHome: true,
    cookiePolicy: false
}

Object.keys(defaults).forEach(item => {
    if (siteMetadata[item] === undefined) {
        siteMetadata[item] = defaults[item]
    }
})

export { siteMetadata, beforeContactFormSubmit, contactFormSubmit }
